import clsx from 'clsx';

interface IRenexisAppLogoSVGProps {
  className?: string;
  /**
   * invert A boolean value to invert the logo color
   */
  invert?: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * This used to render renexis app with logo mark, showing only the `X` part of
 * the logo without the text. To be used in small spaces.
 */
export function RenexisLogomarkSVG({
  className,
  invert = true,
}: IRenexisAppLogoSVGProps) {
  const color = invert ? 'fill-white' : 'fill-gray-950';

  return (
    <svg
      className={clsx('group', color, className)}
      id="renexis-logo-mark"
      viewBox="0 0 54 54"
    >
      <path
        d="
          M53.22 47.87a9.7 9.7 0 0 1-3.65 4.48A9.9 9.9 0 0 1 44.01 54a9.95 9.95
          0 0 1-7.04-2.9L24.33 38.53a9.7 9.7 0 0
          0-5.38-2.71c-.38-.05-.77-.09-1.15-.1-1.31-.05-2.61.16-3.83.63a9.7 9.7
          0 0 0-3.28 2.08l-4.3 4.16c-.5.5-.84 1.13-.97 1.81-.14.69-.07
          1.4.2 2.05a3.57 3.57 0 0 0 3.29 2.19c.93 0 1.83-.36
          2.5-1.02l1.32-1.32-.4-.32c-.34-.27-.6-.64-.75-1.05s-.19-.85-.1-1.28c.08-.43.28-.83.57-1.15.29-.33.67-.56 1.09-.69l3.23-1.01
          3.18-1.21c.41-.15.85-.19 1.28-.12.43.08.83.27 1.16.55s.58.65.72
          1.07c.14.41.16.85.07 1.28l-.41 1.8-.33 1.46-.53 3.34c-.07.43-.25.84-.53
          1.18s-.65.59-1.07.73-.86.17-1.29.08-.83-.3-1.15-.6l-.66-.61-1.61
          1.62a8.94 8.94 0 0 1-6.28 2.58 8.95 8.95 0 0 1-3.93-.94 9.1 9.1 0 0
          1-3.12-2.55A8.9 8.9 0 0 1 .2 46.81c-.27-1.33-.24-2.7.11-4.01a9.03 9.03
          0 0 1 2.43-4.08l4.3-4.16c2.85-2.73 6.66-4.25 10.61-4.22 3.96.03 7.74
          1.59 10.55 4.36l12.65 12.58c.42.42.93.76 1.48.99s1.15.35 1.75.35c.92.02
          1.83-.23 2.6-.74s1.36-1.23 1.7-2.09c.32-.74.44-1.56.33-2.36s-.44-1.56-.95-2.19c-.12-.15-.25-.3-.39-.44l-8.05-7.99a9.21
          9.21 0 0 1-2.56-8.71 9.07 9.07 0 0 1 2.32-4.22l7.1-7.3c.6-.59 1-1.36
          1.16-2.18.16-.83.05-1.68-.29-2.45-.17-.41-.41-.8-.71-1.13-.39-.47-.89-.84-1.45-1.09s-1.17-.38-1.78-.37a4.3
          4.3 0 0 0-3.06 1.27l-7.02 7.08a9.2 9.2 0 0 1-2.98 2.01c-1.12.46-2.32.7-3.53.7-1.2
          0-2.39-.24-3.5-.7a9.1 9.1 0 0 1-2.96-1.99l-7.1-7.09c-.4-.4-.87-.72-1.4-.93-.52-.22-1.08-.33-1.65-.33a4.15
          4.15 0 0 0-1.96.45c-.61.31-1.13.76-1.51 1.32-.18.26-.34.53-.46.82-.35.77-.45
          1.62-.3 2.45s.56 1.59 1.16 2.18h.05l7.25 7.95 4.23
          4.63c-2.19-.18-4.4.12-6.46.88l-8.97-9.83A9.4 9.4 0 0 1 .6 12.17a9.4 9.4
          0 0 1 .45-6.26A9.4 9.4 0 0 1 4.57 1.6 9.55 9.55 0 0 1 9.93 0c1.28 0
          2.54.25 3.72.74s2.25 1.2 3.15 2.1l7.05 7.11c.36.35.77.62 1.24.8.46.18.96.27
          1.45.27.5 0 .99-.08 1.46-.27.46-.18.89-.46 1.24-.8l7.02-7.08c.9-.91
          1.97-1.63 3.15-2.12C40.58.26 41.84 0 43.12 0c1.9-.02 3.76.53 5.35
          1.57a9.43 9.43 0 0 1 3.81 5.02 9.4 9.4 0 0 1-2.21 9.69l-7.11
          7.27c-.07.07-.14.14-.19.22a3.96 3.96 0 0 0-.9 2.68c.05.97.45 1.89
          1.14 2.59l8.06 7.98a9.75 9.75 0 0 1 2.75 5.07c.38 1.93.18 3.93-.6 5.73v.04Z
        "
        id="RenexisLogoMark"
      />
    </svg>
  );
}
